/* eslint-disable @typescript-eslint/default-param-last */
import { GET_MODULES } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { IModulesActionType } from '../types/modules.types';

const modulesReducer = (
  state = initialState.modules,
  action: IModulesActionType
) => {
  switch (action.type) {
    case `${GET_MODULES}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default modulesReducer;
